import axios from "axios";
import { getToken } from "../../auth/auth";

export const findGroups = async (nameStartsWith) => {
  const token = await getToken()
  const c = {
    headers: {
      Authorization: `Bearer ${token.accessToken}`
    }
  }

  const url = `https://graph.microsoft.com/v1.0/groups?$filter=startsWith(displayName,'${nameStartsWith}')&$select=id,displayName`
  try {
    const resp = await axios.get(url, c)
    const { value } = resp.data
    return value
  } catch (error) {
    console.error(error)
  }
  return undefined
}

export const getGroupMembership = async ({uniqueId = undefined, email = undefined}, nameFilterRegex = /NAOU QSE/i) => {
  const token = await getToken()
  const c = {
    headers: {
      Authorization: `Bearer ${token.accessToken}`
    }
  }

  let userUniqueId
  if (uniqueId) {
    userUniqueId = uniqueId
  } else if (email) {
    const userUrl = `https://graph.microsoft.com/v1.0/users?$filter=mail eq '${email}'&$select=id`
    try {
      let response = await axios.get(userUrl, c)
      const {value} = response.data
      userUniqueId = value[0].id
    } catch (error) {
      console.error(error)
      return
    }
  } else {
    userUniqueId = token.uniqueId
  }

  let url = `https://graph.microsoft.com/v1.0/users/${userUniqueId}/memberOf/microsoft.graph.group?$select=displayName,id`
  let groups
  try {
    let response = await axios.get(url, c)
    groups = response.data.value
    while (response.data['@odata.nextLink'] !== undefined && response.status >= 200 && response.status < 400) {
      url = response.data['@odata.nextLink']
      response = await axios.get(url, c)
      groups = [...groups, ...response.data.value]
    }

    if (nameFilterRegex !== undefined) {
      return groups.filter((g) => !!g.displayName && g.displayName.match(nameFilterRegex) !== null)
    } else {
      return groups.filter((g) => !!g.displayName)
    }

  } catch (error) {
    console.error(error)
  }
  return groups
}